// apps/admin/src/hooks/useQueueMachines.ts

import {
  ApiResponse,
  PaginationResponse,
  QueueMachineWithRelations,
} from '@magnetar/admin-api-interfaces'
import { useAuth } from './useAuth'
import { useGet } from './useFetch'

export function useQueueMachines(params?: {
  page?: number
  pageSize?: number
  sortBy?: string
  sortOrder?: 'asc' | 'desc'
  clinic_id?: number
}) {
  const { token } = useAuth()
  const {
    page = 1,
    pageSize = 10,
    sortBy = 'queue_machine_id',
    sortOrder = 'asc',
    clinic_id,
  } = params || {}

  const queryParams: Record<string, string> = {
    page: page.toString(),
    pageSize: pageSize.toString(),
    sortBy,
    sortOrder,
  }

  // 只有在 clinic_id 有值時才加入查詢參數
  if (clinic_id !== undefined) {
    queryParams.clinic_id = clinic_id.toString()
  }

  const queryString = new URLSearchParams(queryParams).toString()

  const { data, error, mutate, isLoading } = useGet<
    ApiResponse<PaginationResponse<QueueMachineWithRelations>>
  >(token ? `/api/queue-machines?${queryString}` : null, undefined, token ?? '')

  return {
    queueMachines: data?.data?.items || [],
    pagination: data?.data
      ? {
          total: data.data.total,
          page: data.data.page,
          pageSize: data.data.pageSize,
          totalPages: data.data.totalPages,
        }
      : null,
    isLoading,
    isError: !!error,
    error,
    mutate,
  }
}
